import { render, staticRenderFns } from "./CoursePrice.vue?vue&type=template&id=c86a1150&"
import script from "./CoursePrice.vue?vue&type=script&lang=js&"
export * from "./CoursePrice.vue?vue&type=script&lang=js&"
import style0 from "./CoursePrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CoursePrice.vue"
export default component.exports